document.addEventListener('DOMContentLoaded', function() {
    "use strict";
    
    // Logo upload functionality
    const uploadBtn = document.getElementById('zwssgr-upload-logo-btn');
    const removeBtn = document.getElementById('zwssgr-remove-logo-btn');
    const fileInput = document.getElementById('organization-logo');
    const logoPreview = document.getElementById('zwssgr-logo-preview');
    const logoIdInput = document.getElementById('organization_logo_id');
    const errorMessageContainer = document.createElement('div'); // Container for error messages
    errorMessageContainer.style.color = 'red';
    errorMessageContainer.style.marginTop = '10px';
    
    if (uploadBtn && removeBtn && fileInput && logoPreview && logoIdInput) {
        uploadBtn.addEventListener('click', function(e) {
            e.preventDefault();
            fileInput.click();
        });
        
        fileInput.addEventListener('change', function() {
            const file = this.files[0];
            
            if (file) {
                // Check file type
                const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
                const fileType = file.type;
                
                // If the file is not an image
                if (!validImageTypes.includes(fileType)) {
                    // Display error message
                    errorMessageContainer.textContent = 'The uploaded file is not a valid image. Please upload a JPG, PNG, or GIF image.';
                    logoPreview.innerHTML = ''; // Clear the preview if there's an error
                    fileInput.value = ''; // Reset the file input
                    logoIdInput.value = ''; // Reset the logo ID input
                    removeBtn.style.display = 'none'; // Hide the remove button
                    if (!document.contains(errorMessageContainer)) {
                        fileInput.parentElement.appendChild(errorMessageContainer); // Append the error message
                    }
                } else {
                    // If the file is a valid image, show preview and remove error message if any
                    errorMessageContainer.textContent = ''; // Clear any previous error messages
                    const reader = new FileReader();
                    
                    reader.onload = function(e) {
                        logoPreview.innerHTML = '<img src="' + e.target.result + '" style="max-width:200px;height:auto;">';
                        removeBtn.style.display = 'inline-block';
                    }
                    
                    reader.readAsDataURL(file);
                    logoIdInput.value = ''; // Clear the ID when uploading a new file
                    if (document.contains(errorMessageContainer)) {
                        fileInput.parentElement.removeChild(errorMessageContainer); // Remove the error message if the upload is valid
                    }
                }
            }
        });
        
        removeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            logoPreview.innerHTML = '';
            fileInput.value = '';
            logoIdInput.value = '';
            removeBtn.style.display = 'none';
            if (document.contains(errorMessageContainer)) {
                fileInput.parentElement.removeChild(errorMessageContainer); // Remove the error message on logo removal
            }
        });
    }
});